import { ReactElement } from 'react';
import { Link } from 'react-router';

import Icon from '../Icon';

import './styles.scss';

export default function BackButton(): ReactElement {
  return (
    <Link
      className="back-button"
      to={`/settings${window.location.search}`}
      replace
    >
      <Icon className="back-arrow" icon="back" />
    </Link>
  );
}
